// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"'styles/breakpoints.module.css'","DESKTOP_WIDTH":"993px","col":"styles_col__0Fx0G"};